var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-view",
    [
      _c("footer-navigation", {
        attrs: { "current-page": _vm.Resources.Layout.WhyGamefoundLink },
      }),
      _vm._v(" "),
      _c("base-hero", {
        attrs: {
          title: "Why Gamefound?",
          description:
            "Gamefound is the best place to launch your tabletop game. We help you every step of the way, from funding to fulfillment.",
          type: "whyGamefound",
        },
      }),
      _vm._v(" "),
      _c(
        "base-container",
        { staticClass: "_flexcol _gap-6 _py-6", attrs: { width: "narrow" } },
        [
          _c(
            "box",
            { staticClass: "_flexcol _gap-6", attrs: { huge: "" } },
            [
              _c("div", { staticClass: "_tac" }, [
                _c("h3", { staticClass: "gfu-hd gfu-hd--h2" }, [
                  _vm._v(_vm._s(_vm.ecoSystem.title)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "gfu-bt gfu-bt--b1" }, [
                  _vm._v(_vm._s(_vm.ecoSystem.subtitle)),
                ]),
              ]),
              _vm._v(" "),
              _vm._l(_vm.ecoSystem.items, function (item) {
                return _c(
                  "div",
                  { key: item.icon, staticClass: "_flex _gap-3" },
                  [
                    _c(
                      "div",
                      [
                        _c("base-icon", {
                          staticClass: "_tc--accent",
                          attrs: {
                            name: item.icon,
                            "icon-namespace": item.iconNameSpace,
                            "is-fixed-width": "",
                            "has-base-class": "",
                            size: "lg",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "gfu-bt gfu-bt--b1" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(item.text) +
                          "\n                    "
                      ),
                      item.url
                        ? _c(
                            "a",
                            {
                              staticClass: "gfu-link gfu-link--accent",
                              attrs: {
                                href: item.url,
                                target: "_blank",
                                rel: "noopener noreferrer",
                              },
                            },
                            [
                              _vm._v(
                                "\n                        learn more\n                        "
                              ),
                              _c("base-icon", {
                                attrs: { name: "chevron-right", size: "sm" },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]
                )
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("base-quote", {
            attrs: {
              author: _vm.quotes.goOnBoard.author,
              quote: _vm.quotes.goOnBoard.text,
            },
          }),
          _vm._v(" "),
          _c("div", [
            _c("h3", { staticClass: "gfu-hd gfu-hd--h1" }, [
              _vm._v("Want more details? We're happy to share!"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "gfu-bt gfu-bt--b1" }, [
              _vm._v(
                "\n                Gamefound supports creators of all sizes - whether you're just starting out or already a major player.\n                Here are just a few examples from each category:\n            "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("why-gamefound-project-explorer", {
            attrs: { "project-categories": _vm.projectCategories },
          }),
          _vm._v(" "),
          _c("base-quote", {
            attrs: {
              author: _vm.quotes.gabeBarrett.author,
              quote: _vm.quotes.gabeBarrett.text,
            },
          }),
          _vm._v(" "),
          _c("div", [
            _c("h3", { staticClass: "gfu-hd gfu-hd--h1" }, [
              _vm._v("Feature comparison"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "gfu-bt gfu-bt--b1" }, [
              _vm._v(
                "\n                Features that set Gamefound apart from the competition.\n            "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "box",
            { staticClass: "_ov-h", attrs: { content: "" } },
            [
              _c("grid-table", {
                scopedSlots: _vm._u([
                  {
                    key: "head",
                    fn: function () {
                      return [
                        _c(
                          "grid-table-row",
                          [
                            _c(
                              "grid-table-cell",
                              {
                                staticClass: "_tc--light _fw-n",
                                attrs: { width: 70 },
                              },
                              [_vm._v("Feature")]
                            ),
                            _vm._v(" "),
                            _c(
                              "grid-table-cell",
                              { attrs: { width: 15, "text-align": "center" } },
                              [
                                _vm.isSignetVisible
                                  ? _c("base-image", {
                                      attrs: {
                                        src: "/content/images/site-icon.svg",
                                        alt: "Gamefound",
                                      },
                                    })
                                  : _c("themed-image", {
                                      staticClass: "_px-2",
                                      attrs: {
                                        src: "/content/images/static/logo/site-logo.svg",
                                        alt: "Gamefound",
                                      },
                                    }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "grid-table-cell",
                              { attrs: { width: 15, "text-align": "center" } },
                              [_vm._v("Kickstarter")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "body",
                    fn: function () {
                      return _vm._l(_vm.features, function (feature) {
                        return _c(
                          "grid-table-row",
                          { key: feature.name },
                          [
                            _c("grid-table-cell", { attrs: { width: 70 } }, [
                              _c("h5", { staticClass: "gfu-hd gfu-hd--h4" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(feature.name) +
                                    "\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "gfu-bt gfu-bt--caption _screen--none _screen--m",
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(feature.text) +
                                      "\n                                "
                                  ),
                                  feature.url
                                    ? _c(
                                        "a",
                                        {
                                          staticClass:
                                            "gfu-link gfu-link--accent _whs-nw",
                                          attrs: {
                                            href: feature.url,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    learn more\n                                    "
                                          ),
                                          _c("base-icon", {
                                            attrs: {
                                              name: "chevron-right",
                                              size: "sm",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "grid-table-cell",
                              { attrs: { width: 15, "text-align": "center" } },
                              [
                                feature.mark
                                  ? _c("themed-image", {
                                      staticClass: "gfu-3of4--l",
                                      attrs: {
                                        src: "/content/images/static/logo/adfound-logo.svg",
                                      },
                                    })
                                  : _c("base-icon", {
                                      staticClass: "_tc--accent",
                                      attrs: { name: "check", size: "lg" },
                                    }),
                                _vm._v(" "),
                                feature.gamefound
                                  ? _c("base-icon", {
                                      staticClass: "_tc--accent",
                                      attrs: { name: "check", size: "lg" },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "grid-table-cell",
                              { attrs: { width: 15, "text-align": "center" } },
                              [
                                _c("base-icon", {
                                  staticClass: "_tc--light",
                                  attrs: { name: "times", size: "lg" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      })
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("base-quote", {
            attrs: {
              author: _vm.quotes.creativeGameStudio.author,
              quote: _vm.quotes.creativeGameStudio.text,
            },
          }),
          _vm._v(" "),
          _c("div", [
            _c("h3", { staticClass: "gfu-hd gfu-hd--h1" }, [
              _vm._v("Beyond the obvious"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "gfu-bt gfu-bt--b1" }, [
              _vm._v(
                "\n                How Gamefound actually works for you\n            "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "box",
            {
              staticClass: "_grid _grid-cols-1 _grid-cols-2--l _gap-6",
              attrs: { huge: "" },
            },
            [
              _c("div", { staticClass: "_flexcol _jc-c" }, [
                _c("h3", { staticClass: "gfu-hd gfu-hd--h1 _mb-1" }, [
                  _vm._v("Even 49% better results on Gamefound"),
                ]),
                _vm._v(
                  "\n                Features like Follower Gifts, Stretch Pay, Endgame, and multiple payment methods can significantly boost your campaign’s performance — sometimes without you even realizing it.\n                This is the kind of extra lift you might not have known was possible.\n            "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("themed-image", {
                    attrs: { src: "/content/images/static/why-gf/perks.svg" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("themed-image", {
                    attrs: {
                      src: "/content/images/static/why-gf/reprints.svg",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "_flexcol _jc-c" }, [
                _c("h3", { staticClass: "gfu-hd gfu-hd--h1 _mb-1" }, [
                  _vm._v("Reprints earn 64% more on Gamefound"),
                ]),
                _vm._v(
                  "\n                Launching again? Creators see major gains on Gamefound when reprinting previous titles. With optimized conversion tools and an active community, your next run might just outperform your first.\n            "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "_flexcol _jc-c" }, [
                _c("h3", { staticClass: "gfu-hd gfu-hd--h1 _mb-1" }, [
                  _vm._v("There’s 65% more to come after crowdfunding"),
                ]),
                _vm._v(
                  "\n                On average, creators raise an additional 65% during the Late Pledge and Pledge Manager phases. With Gamefound, your campaign keeps growing even after the main funding ends.\n            "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("themed-image", {
                    attrs: { src: "/content/images/static/why-gf/tree.svg" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("themed-image", {
                    attrs: {
                      src: "/content/images/static/why-gf/popup-promo.svg",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "_flexcol _jc-c _gap-1" }, [
                _c("h3", { staticClass: "gfu-hd gfu-hd--h1" }, [
                  _vm._v(
                    "Adfound - the elite marketing tool built into Gamefound"
                  ),
                ]),
                _vm._v(
                  "\n                Reach the right backers at the right time. Adfound supports flexible ad budgeting and tracks performance from pre-launch to post-campaign — helping you grow followers, boost sales, and get more from every ad dollar.\n                "
                ),
                _c(
                  "div",
                  { staticClass: "_pt-1" },
                  [
                    _c(
                      "base-button",
                      {
                        attrs: {
                          theme: "accent",
                          tag: "a",
                          href: _vm.performanceMarketingUrl,
                        },
                      },
                      [_vm._v("Learn more")]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "_col-span-2--l _tac" }, [
                _c("h4", { staticClass: "gfu-hd gfu--h3" }, [
                  _vm._v(
                    "Thanks to Gamefound’s features, your campaign can reach its full potential."
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("base-quote", {
            attrs: {
              author: _vm.quotes.chipTheoryGames.author,
              quote: _vm.quotes.chipTheoryGames.text,
            },
          }),
          _vm._v(" "),
          _c("div", [
            _c("h3", { staticClass: "gfu-hd gfu-hd--h1" }, [
              _vm._v("Growth in numbers"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "gfu-bt gfu-bt--b1" }, [
              _vm._v(
                "\n                A breakdown of our core indicators, year over year — and they speak volumes.\n            "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "_grid _grid-cols-1 _grid-cols-2--l _gap-6" },
            [
              _c("themed-image", {
                attrs: { src: "/content/images/static/why-gf/users-graph.svg" },
              }),
              _vm._v(" "),
              _c("themed-image", {
                attrs: {
                  src: "/content/images/static/why-gf/revenue-graph.svg",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("base-quote", {
            attrs: {
              author: _vm.quotes.hexPloreIt.author,
              quote: _vm.quotes.hexPloreIt.text,
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "_grid _grid-cols-1 _grid-cols-2--l _gap-6" },
            [
              _c(
                "box",
                [
                  _c("h3", { staticClass: "gfu-hd gfu-hd--h1 _mb-2" }, [
                    _vm._v("I am ready to try Gamefound"),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "\n                    Create a free test campaign and see how Gamefound works - no commitment needed. Explore the features,\n                    build your page, and experience the full toolset before you go live. It’s the easiest way to get started.\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "base-button",
                    {
                      staticClass: "_mt-6",
                      attrs: {
                        tag: "a",
                        href: _vm.createCreatorAccountUrl,
                        theme: "accent",
                      },
                    },
                    [
                      _vm._v(
                        "\n                    Become a creator\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "box",
                [
                  _c("h3", { staticClass: "gfu-hd gfu-hd--h1 _mb-2" }, [
                    _vm._v("Not convinced yet?"),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "\n                    Want to dig deeper before you decide? You can learn more about the platform, explore detailed data,\n                    and if you still have questions, feel free to reach out to us via our\n                    "
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "_tc--accent",
                        attrs: { href: _vm.contactForCreatorsUrl },
                      },
                      [_vm._v("contact form")]
                    ),
                    _vm._v(".\n                "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "base-button",
                    {
                      staticClass: "_mt-6",
                      attrs: {
                        tag: "a",
                        href: _vm.becomeACreatorUrl,
                        theme: "accent",
                      },
                    },
                    [
                      _vm._v(
                        "\n                    Learn more\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }